import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SelectInstrumentRequest } from '@cash-web/shared-util-protos/squareup/cash/moneta/api/v1_0/plasma/app.pb'
import { SelectInstrumentResponse } from '@cash-web/shared-util-protos/squareup/cash/moneta/api/v1_0/plasma/app.pb'

export const selectInstrument = (request: SelectInstrumentRequest, options?: CashRequestOptions) =>
  post<SelectInstrumentRequest, SelectInstrumentResponse>('/2.0/cash/select-instrument', request, {
    ...options,
    rejectOnError: true,
  })
